<template>
  <div class="runmode">
  </div>
</template>

<script>
export default {
  name: 'runmodeLoading',
  mounted: function() {
    this.$emit('mounted')
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/style/runmode_common';
</style>



// WEBPACK FOOTER //
// RunmodeLoading.vue?6f65adb8